export default {
  WEBSITE: 'WEBSITE',
  PAGE: 'PAGE',
  EVENTS: 'EVENTS'
};